import { FIND_COMPANY } from "./../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function findCompany(props: IFindUserInformation) {
  let body: any = {
    page: props.page,
    limit: props.limit,
    userType: "COMPANY",
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
      // [String(props.search.base)]: utils.convertNumbers2English(
      //   props.search.value
      // ),
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { province, city } = props.filters;
    body = {
      ...body,
      province: province?._id,
      city: city?._id,
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(FIND_COMPANY, body)).data;
  } catch (error: any) {
    console.error({ FIND_COMPANY: error });
  }
}

export default findCompany;
